'use client';
import type { TicketMap } from '@ticketevolution/seatmaps-client';
import { useEffect, useRef, useState } from 'react';

export type TicketGroup = {
  tevo_section_name: string;
  retail_price: number;
};

export type PublicApi = {
  updateTicketGroups: (ticketGroups: TicketGroup[]) => void;
  highlightSection: (section: string) => void;
  unhighlightSection: (section?: string) => void;
  selectSection: (section: string) => void;
  deselectSection: (section?: string) => void;
};

const useTicketEvoMap = (): {
  ref: React.RefObject<TicketMap>;
  handle: PublicApi | null;
} => {
  const ref = useRef<TicketMap>(null);
  const [handle, setHandle] = useState<PublicApi | null>(null);

  useEffect(() => {
    // TicketMap mounts async map assets; poll briefly until publicApi is ready.
    setHandle(ref.current?.publicApi ?? null);

    let attempts = 0;
    const maxAttempts = 40;
    const interval = window.setInterval(() => {
      attempts += 1;
      const api = ref.current?.publicApi ?? null;
      if (api) {
        setHandle(api);
        window.clearInterval(interval);
        return;
      }
      if (attempts >= maxAttempts) {
        window.clearInterval(interval);
      }
    }, 100);

    return () => window.clearInterval(interval);
  }, []);

  return { ref, handle };
};

export default useTicketEvoMap;
